import { Controller } from "@hotwired/stimulus";
import uppy from "../lib/uppy";

// Connects to data-controller="uppy"
export default class extends Controller {
  static targets = ["actions", "input", "uploader"];

  connect() {
    if (!this.hasInputTarget) {
      return;
    }
    const uppyContainer = document.createElement("div");
    this.inputTarget.after(uppyContainer);
    this.inputTarget.classList.add("hidden");

    const inputTarget = this.inputTarget;

    const field = this.element.dataset.field;
    const url = this.element.dataset.url;
    const note = this.element.dataset.note;
    const maxFileSize = this.element.dataset.maxFileSize;
    let allowedFileTypes = ["image/*"];
    if (this.element.dataset.accept) {
      allowedFileTypes = this.element.dataset.accept.split(",");
    }

    const callback = function (file, uploadedFileData) {
      if (uploadedFileData.metadata.mime_type.startsWith("image")) {
        const newValue = JSON.stringify(uploadedFileData);
        const newUrl = new URL(url);
        newUrl.searchParams.delete("change");
        newUrl.searchParams.append(field, newValue);
        document.getElementById(`uppy-${field}`).src = newUrl.toString();
      } else {
        const filename = document.createElement("div");
        filename.textContent = uploadedFileData.metadata.filename;
        uppyContainer.after(filename);
      }
      inputTarget.type = "hidden";
      inputTarget.value = JSON.stringify(uploadedFileData);
      uppyContainer.classList.add("hidden");
    };

    this.uppy = uppy.create(uppyContainer, {
      maxNumberOfFiles: 1,
      eachFileCallback: callback,
      note: note,
      maxFileSize: maxFileSize,
      allowedFileTypes: allowedFileTypes,
    });
  }

  disconnect() {
    if (this.uppy) {
      this.uppy.destroy();
    }
  }
}
